import { IFRResource } from "app/resources/ifrresource";
import { RoleResource } from "app/resources/role/role-resource";

export class RoleListResource extends IFRResource {

 roles: RoleResource[];
}
